module.exports = __webpack_public_path__ + "img/banner.bee81958.png";